import i18n from '../../managers/i18n'

i18n.register(
  'zh-Hans',
  {
    ok: '知道了'
  },
  {
    ns: 'alertbox'
  }
)
